<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f015-03.jpg" width="80%"/></p>
<p class="caption"><em class="italic">Major General Edward Allenby</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 22_fm035.vue?82416efc